import { message, Upload } from 'hljd'
import React, { Component } from 'react'
import Sorter from '../Sorter/index'
import styles from './style.module.less'
const dpr = window.devicePixelRatio

export default class extends Component {
  render() {
    const {
      value = [],
      onChange = () => {},
      onLoad = () => {},
      max = 50,
      maxSize = 10,
      maxHeight = 8192,
      maxWidth
    } = this.props

    const remain = max - value.length

    const preChecker = async (file, fileList) => {
      const { height, width } = await Upload.checkSizeSync(file)

      if (fileList.length > max) {
        message.error({
          content: `上传图片不得超过${max}张，请重新选择`,
          key: 'picNum'
        })
        return Promise.reject(file)
      }

      if (maxHeight && height > maxHeight) {
        message.error({
          content: `不得包含高度超过${maxHeight}像素的图片，请重新选择`,
          key: 'picHeight'
        })
        return Promise.reject(file)
      }

      if (maxWidth && width > maxWidth) {
        message.error({
          content: `不得包含宽度超过${maxWidth}像素的图片，请重新选择`,
          key: 'picHeight'
        })
        return Promise.reject(file)
      }

      if (maxSize && file.size > 1024 * 1024 * maxSize) {
        message.error({
          content: `不得包含大小超过${maxSize}M的图片，请重新选择`,
          key: 'picSize'
        })
        return Promise.reject(file)
      }

      return Promise.resolve(file)
    }

    const onDelete = item => {
      const newData = value.filter(e => {
        if (e?.id && item?.id) {
          return e?.id !== item?.id
        } else if (e?.uid && item?.uid) {
          return e?.uid !== item?.uid
        } else {
          return e?.url !== item?.url
        }
      })
      onChange(newData)
    }

    const done = e => {
      onLoad(true)
      onChange(e)
    }

    return (
      <div className={styles.sortUpload}>
        <Sorter
          onSortEnd={e => onChange(e)}
          data={value}
          render={item => (
            <div
              className={styles.item}
              style={{
                width: 120,
                height: 120,
                backgroundImage: `url("${item?.url}?imageView2/2/w/${Math.round(
                  120 * dpr
                )}/h/${Math.round(120 * dpr)}")`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain'
              }}
            >
              <div className={styles.close} onClick={() => onDelete(item)} />
            </div>
          )}
        >
          {remain > 0 && (
            <Upload
              accept="image/jpeg,image/jpg,image/png,image/bmp"
              listType="picture-card"
              multiple
              sortable={true}
              width={120}
              height={120}
              max={max}
              value={value}
              beforeUpload={preChecker}
              onChange={e => done(e)}
              onProcess={() => onLoad(false)}
            />
          )}
        </Sorter>
      </div>
    )
  }
}
